function isIconOnly(props) {
    return !!props.icon && !props.children;
}

export { isIconOnly as default };
//# sourceMappingURL=isIconOnly.esm.js.map
